import Vue from "vue";
import Vuex from "vuex";
//import axios from "axios";

/*NO MONGO*/
import daysData from "@/assets/database/days.json";
import cardsData from "@/assets/database/cards.json";
import imagesData from "@/assets/database/images.json";
import storiesData from "@/assets/database/instaStories.json";
import notebookData  from "@/assets/database/notebooks.json";

Vue.use(Vuex);
//const url_api = "http://192.168.24.149:3000/api";

// The socket server doesn't send the current day to clients that (re)connect,
// so remember the last day received; a page reload then resumes on it.
const ACTIVE_DAY_KEY = "wildtech.activeDay";
const readStoredDay = () => {
  try {
    const n = parseInt(localStorage.getItem(ACTIVE_DAY_KEY), 10);
    return Number.isInteger(n) && n >= 0 ? n : 0;
  } catch (e) {
    return 0;
  }
};

export default new Vuex.Store({
  state: {
    inExperience: false,
    loading: true,
    days: [],
    cards: [],
    notebook: [],
    images: [],
    instaStories: [],
    activeDay: readStoredDay(),
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setInExperience(state, ex) {
      state.inExperience = ex;
    },
    setActiveDay(state, dayNumber) {
      const day = Number(dayNumber);
      if (!Number.isInteger(day) || day < 0) return;
      state.activeDay = day;
      try {
        localStorage.setItem(ACTIVE_DAY_KEY, String(day));
      } catch (e) {
        // storage unavailable (private mode): keep working without it
      }
    },
    setDays(state, days) {
      state.days = days;
    },
    setCards(state, cards) {
      state.cards = cards;
    },
    setNotebook(state, notebook) {
      state.notebook = notebook;
    },
    setImages(state, images) {
      state.images = images;
    },
    setInstaStories(state, instaStories) {
      state.instaStories = instaStories;
    },
  },
  actions: {
    fetchAllData({ dispatch, commit, state }) {
      commit("setLoading", true);
      console.log("Loading before", state.loading);
      let days = dispatch("fetchDays");
      let cards = dispatch("fetchCards");
      let notebook = dispatch("fetchNotebook");
      let images = dispatch("fetchImages");
      let instaStories = dispatch("fetchInstaStories");

      return Promise.all([days, cards, notebook, images, instaStories]).then(() => {
        // Both done
        commit("setLoading", false);
        console.log("Loading after", state.loading);
      });
    },
    fetchDays({ state, commit }) {
      console.log("Fetch Days");
      return new Promise((resolve) => {
        /*NO MONGO*/
        let days = daysData;
       
        commit("setDays", days);
        resolve(state.days);
        /*MONGODB*/
        /*
        const url = url_api + "/days";
        // https://docs.nativescript.org/http.html
        axios
          .get(url)
          .then((res) => {
            console.log(res.data);
            commit("setDays", res.data);
            resolve(state.days);
          })
          .catch((err) => console.log("error", err));
        */
      });
    },
    fetchCards({ state, commit }) {
      console.log("Fetch Cards");
      return new Promise((resolve) => {
        /*NO MONGO*/
        /*NO MONGO*/
        let cards= cardsData;
        commit("setCards", cards);
        resolve(state.cards);
        /*MONGODB*/
        /*
        const url = url_api + "/cards";
        // https://docs.nativescript.org/http.html
        axios
          .get(url)
          .then((res) => {
            console.log(res.data);
            commit("setCards", res.data);
            resolve(state.cards);
          })
          .catch((err) => console.log("error", err));
        */
      });
    },
    fetchNotebook({ state, commit }) {
      console.log("Fetch Notebook");
      return new Promise((resolve) => {
        /*NO MONGO*/
        let notebook= notebookData;
        commit("setNotebook", notebook);
        resolve(state.notebook);
        /*MONGODB*/
        /*
        const url = url_api + "/notebooks";
        // https://docs.nativescript.org/http.html
        axios
          .get(url)
          .then((res) => {
            console.log(res.data);
            commit("setNotebook", res.data);
            resolve(state.notebook);
          })
          .catch((err) => console.log("error", err));
        */
      });
    },
    fetchImages({ state, commit }) {
      console.log("Fetch Images");
      return new Promise((resolve) => {
        /*NO MONGO*/
        let images= imagesData;
        commit("setImages", images);
        resolve(state.images);
        /*MONGODB*/
        /*
        const url = url_api + "/images";
        // https://docs.nativescript.org/http.html
        axios
          .get(url)
          .then((res) => {
            console.log(res.data);
            commit("setImages", res.data);
            resolve(state.images);
          })
          .catch((err) => console.log("error", err));
        */
      });
    },
    fetchInstaStories({ state, commit }) {
      console.log("Fetch InstaStories");
      return new Promise((resolve) => {
        /*NO MONGO*/
        let instaStories= storiesData;
        commit("setInstaStories", instaStories);
        resolve(state.instaStories);
        /*MONGODB*/
        /*
        const url = url_api + "/instaStories";
        // https://docs.nativescript.org/http.html
        axios
          .get(url)
          .then((res) => {
            console.log(res.data);
            commit("setInstaStories", res.data);
            resolve(state.instaStories);
          })
          .catch((err) => console.log("error", err));
        */
      });
    },
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    inExperience(state) {
      return state.inExperience;
    },
    cards(state) {
      return state.cards;
    },
    activeDay(state) {
      return state.activeDay;
    },
    notebook(state) {
      return state.notebook;
    },
    images(state) {
      return state.images;
    },
    days(state) {
      return state.days;
    },
    instaStories(state) {
      return state.instaStories;
    },
  },
  modules: {},
});
